module.exports = __webpack_public_path__ + "static/media/Whatsapp.03a70e1d.svg";